import { Sponsor, Document } from '../types';

export const partners: Sponsor[] = [
  {
    name: "Urząd Miejski w Chodzieży",
    img_path: "/images/sponsors/Chodzież logo.svg",
    url_path: "https://samorzad.gov.pl/web/miasto-chodziez"
  },
  {
    name: "DLRG",
    img_path: "/images/sponsors/dlrg.png",
    url_path: "https://nottuln.dlrg.de/"
  },
  {
    name: "GIBAS",
    img_path: "/images/sponsors/gibas.png",
    url_path: "https://grupagibas.pl/"
  },
  {
    name: "GTW Marine",
    img_path: "/images/sponsors/gtw_marine.jpeg",
    url_path: "https://gtwmarine.pl/"
  },
  {
    name: "MOSiR Chodzież",
    img_path: "/images/sponsors/mosir_chz.png",
    url_path: "http://mosir-chodziez.pl/"
  },
  {
    name: "Powiat Chodzieski",
    img_path: "/images/sponsors/powiat_nobg.png",
    url_path: "https://www.powiat-chodzieski.pl/"
  },
  {
    name: "PZMWiNW",
    img_path: "/images/sponsors/pzmwinw.jpg",
    url_path: "https://www.motorowodniacy.org/"
  },
  {
    name: "WOPR",
    img_path: "/images/sponsors/wopr.png",
    url_path: "https://woprwielkopolska.pl/"
  },
  {
    name: "Wszech-Dach",
    img_path: "/images/sponsors/wszech_dach.avif",
    url_path: "https://www.wszechdach.pl/"
  }
];

export const documents: Document[] = [
  {
    name: "documents.files.statute",
    path: "/documents/STATUT.pdf"
  },
  {
    name: "documents.files.minors_protection",
    path: "/documents/Standardy Ochrony Małoletnich.pdf"
  },
  {
    name: "documents.files.reapplication",
    path: "/documents/wniosek-o-ponowne-przyjecie.pdf"
  },
  {
    name: "documents.files.application",
    path: "/documents/wniosek-o-przyjecie.pdf"
  },
  {
    name: "documents.files.data_update",
    path: "/documents/Aktualizacja danych osobowych WOPR.pdf"
  }
];
